// extracted by mini-css-extract-plugin
module.exports = {"confirmationSpacing":"reset-password-confirmation_w2WEH"};